export default () => {
  const route = useRoute();

  return {
    current_page: Number(route.query.page) || 1,
    total_pages: 1,
    total: 0,
    count: 0,
    per_page: Number(route.query.per_page) || 10,
    last_page: 0,
  };
};
